import React, { useEffect, useRef, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import '../../css/ChipScrollBar.css';

// チップ列の横スクロールビューポート共通部品。
// 品番マスタ(HinbanMaster)と加工指示(Kakousiji)のヘッダチップバーで共用する。
//
// - children(チップ列)は縮小させず、指定幅からはみ出す場合のみ [<][>] を表示する
// - [>]で表示幅の8割ぶん右へ、[<]で左へスムーズスクロールする
// - 収まっている場合は両ボタンとも表示しない
// - 親要素は display:flex であること(ビューポートが flex:1 で余白を埋める)
export default function ChipScrollBar({ children, className = '' }) {
    const viewportRef = useRef(null);
    const [scrollState, setScrollState] = useState({ canLeft: false, canRight: false });
    function updateScrollState() {
        const el = viewportRef.current;
        if (el === null) return;
        const canLeft = el.scrollLeft > 1;
        const canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
        setScrollState((prev) => (prev.canLeft === canLeft && prev.canRight === canRight ? prev : { canLeft, canRight }));
    }
    function scrollByDirection(direction) {
        const el = viewportRef.current;
        if (el === null) return;
        const amount = Math.max(120, Math.floor(el.clientWidth * 0.8));
        el.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    useEffect(() => {
        updateScrollState();
        const el = viewportRef.current;
        if (el !== null && typeof ResizeObserver === 'function') {
            // 同期的に状態更新すると矢印の出没で再度リサイズが起き、
            // "ResizeObserver loop completed" エラーになるため1フレーム遅らせる。
            const observer = new ResizeObserver(() => {
                window.requestAnimationFrame(() => updateScrollState());
            });
            observer.observe(el);
            // 中身(チップ列)の幅変化も拾う(チップの増減など)
            if (el.firstElementChild !== null) observer.observe(el.firstElementChild);
            return () => observer.disconnect();
        }
        window.addEventListener('resize', updateScrollState);
        return () => window.removeEventListener('resize', updateScrollState);
    }, []);
    const showArrows = scrollState.canLeft || scrollState.canRight;
    return (
        <React.Fragment>
            {!showArrows ? null :
                <IconButton size="small" className="chip-scrollbar-arrow" title="前へ" disabled={!scrollState.canLeft} onClick={() => scrollByDirection(-1)}>
                    <Icon>chevron_left</Icon>
                </IconButton>
            }
            <div className={'chip-scrollbar-viewport' + (className === '' ? '' : ' ' + className)} ref={viewportRef} onScroll={updateScrollState}>
                {children}
            </div>
            {!showArrows ? null :
                <IconButton size="small" className="chip-scrollbar-arrow" title="次へ" disabled={!scrollState.canRight} onClick={() => scrollByDirection(1)}>
                    <Icon>chevron_right</Icon>
                </IconButton>
            }
        </React.Fragment>
    );
}
